import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

const repairSlice = createSlice({
  name: "sRepair",
  initialState,
  reducers: {
    add(state, action) {
      state.push(action.payload);
    },
    remove(state, action) {
      return state.filter((item) => item.id !== action.payload);
    },
  },
});

export const { add, remove } = repairSlice.actions;
export default repairSlice.reducer;
